import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";

const BudgetsAndSales = ({ data }) => {
  const [chartData, setChartData] = useState({ series: [], options: {} });

  useEffect(() => {
    const topicsSet = new Set();
    const yearsSet = new Set();
    data.forEach((val) => {
      const date = new Date(val.published);
      const year = date.getFullYear();
      const topic = val.topic.trim().toLowerCase();
      if (topic) topicsSet.add(topic);
      if (!isNaN(year)) yearsSet.add(year);
    });

    const yearTopicCount = [];
    yearsSet.forEach((year) => {
      let maxTopic = "";
      let maxCount = 0;
      topicsSet.forEach((topic) => {
        const count = data.filter(
          (val) =>
            new Date(val.published).getFullYear() === year &&
            val.topic.trim().toLowerCase() === topic
        ).length;
        if (count > maxCount) {
          maxCount = count;
          maxTopic = topic;
        }
      });
      yearTopicCount.push({ year, topic: maxTopic, count: maxCount });
    });

    yearTopicCount.sort((a, b) => b.year - a.year);

    const yearArray = yearTopicCount.map((val) => val.year);
    const topicsArray = yearTopicCount.map((val) => val.topic);
    const countArray = yearTopicCount.map((val) => val.count);

    setChartData({
      series: [
        { name: "Year", group: "topics", data: yearArray },
        { name: "This Topics Occur", group: "topics", data: countArray },
      ],
      options: {
        chart: { type: "bar", height: 100, stacked: true },
        stroke: { width: 1, colors: ["#fff"] },
        plotOptions: { bar: { horizontal: false } },
        xaxis: { categories: topicsArray },
        fill: { opacity: 1 },
        colors: ["#80c7fd", "#008FFB", "#80f1cb", "#00E396"],
        legend: { position: "top", horizontalAlign: "left" },
        title: {
          text: "Top Topics Year wise",
          align: "center",
          style: {
            fontSize: "18px",
            fontWeight: "bold",
            fontFamily: "Arial, sans-serif",
            color: "#333",
          },
        },
      },
    });
  }, [data]);

  return (
    <div id="chart">
      <ReactApexChart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height={280}
      />
    </div>
  );
};

export default BudgetsAndSales;